<template>
  <v-sheet class="banner-top" color="#c6d053">
    <img
      :src="
        smAndDown
          ? `/img/algoamais/banner_top_mobile.png`
          : `/img/algoamais/banner_top.png`
      "
    />
  </v-sheet>
</template>

<script>
export default {
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-top {
  img {
    aspect-ratio: 1920 / 920;
    display: block;
    -o-object-fit: cover;
    object-fit: cover;
    width: 100%;

    @media screen and (max-width: 960px) {
      aspect-ratio: 600 / 600;
    }
  }
}
</style>
